import { useEffect } from 'react'

/**
 * **Die App-Hülle steht — die Schnelleingabe darf vorgewärmt werden** (Sven, 04.10.2026).
 *
 * Aus `MainLayout`, also erst angemeldet und in der App. Ein Hauptfenster allein reicht nicht: Es zeigt
 * nach Abmelden oder abgelaufener Sitzung die Anmeldeseite, und eine dann vorgewärmte Schnelleingabe
 * leitete sich selbst nach `/` um und blieb dort (Diff-Audit 04.10.2026). Den Verzug und das
 * „schon da“ regelt der Hauptprozess (`scheduleQuickAddPrewarm`). Im Web fehlt der Kanal.
 */
export function useQuickAddPrewarm(): void {
  useEffect(() => {
    void window.windowAPI?.prewarmQuickAdd?.()
  }, [])
}
